import type { JobLogEntry } from "./parseJobLogEvent";

import { transientJobUrls } from "../api/urls";
import { emitParsedLogLines, splitLogStreamLines } from "./parseJobLogEvent";

type ReadJobLogStreamParams = {
  accessToken: string;
  errorMessage: string;
  jobId: string;
  onLine: (line: JobLogEntry) => void;
  signal: AbortSignal;
};

export const readJobLogStream = async ({
  accessToken,
  errorMessage,
  jobId,
  onLine,
  signal,
}: ReadJobLogStreamParams) => {
  const response = await fetch(transientJobUrls.logs(jobId), {
    headers: {
      Accept: "text/event-stream",
      Authorization: accessToken ? `Bearer ${accessToken}` : "",
    },
    signal,
  });

  if (!response.ok || !response.body) {
    throw new Error(errorMessage);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  while (!signal.aborted) {
    const { done, value } = await reader.read();
    if (done) {
      buffer += decoder.decode();
      const { lines, rest } = splitLogStreamLines(`${buffer}\n`);
      emitParsedLogLines(lines, onLine);
      if (rest) emitParsedLogLines([rest], onLine);
      break;
    }
    buffer += decoder.decode(value, { stream: true });
    const { lines, rest } = splitLogStreamLines(buffer);
    buffer = rest;
    emitParsedLogLines(lines, onLine);
  }
};
